var AStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { ModuleConfig } from "../../models/module-config.model";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { AppControllerService } from "../../../app-controller.service";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { ODataAction } from "../odata-query/odata-action.model";
import { ViewApplicationDocumentationComponent } from "../../../view-application/view-application-documentation/view-application-documentation.component";
import { CreateApplicationDocumentationComponent } from "../../../create-application/create-application-documentation/create-application-documentation.component";
import { AlertType } from "../../models/alert";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { SharedConstants } from "../../constants/shared.constants";
import { map } from "rxjs/operators";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { minLengthArray } from "../../classes/min-length-array-validator";
import { ViewApplicationDetailsAComponent } from "../../../view-application/modules/a/view-application-details-a/view-application-details-a.component";
import { ViewApplicationLocationAComponent } from "../../../view-application/modules/a/view-application-location-a/view-application-location-a.component";
import { CreateApplicationDetailsAComponent } from "../../../create-application/modules/a/create-application-details-a/create-application-details-a.component";
import { CreateApplicationLocationAComponent } from "../../../create-application/modules/a/create-application-location-a/create-application-location-a.component";
import { ApiAdvertisingConstants } from "../../constants/api-constants/api-advertising.constants";
import { phoneNumberValidator } from "../../classes/phone-number-validator";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { CreateApplicationLocationAConstants } from "../../../create-application/modules/a/create-application-location-a/create-application-location-a.constants";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([[ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"], [ApplicationHeadingEnum.Applicant, "applicant"], [ApplicationHeadingEnum.ApplicationType, "type"], [ApplicationHeadingEnum.CreatedDate, "startDate"], [ApplicationHeadingEnum.ApplicationStatus, "phase"], [ApplicationHeadingEnum.DaysLeft, "daysLeft"], [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"], [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([[ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"], [ApplicationSummaryColumnsEnum.Applicant, "applicant"], [ApplicationSummaryColumnsEnum.ApplicationType, "type"], [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"], [ApplicationSummaryColumnsEnum.Phase, "phase"], [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"], [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"], [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"]]);
export const AExpandListForApplicationSearch = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_A;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationMenuHeadings["Location"] = "Location details";
    CreateApplicationMenuHeadings["Details"] = "Application details";
    CreateApplicationMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
    CreateApplicationMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Location help";
    HeaderConfigurableTextTypes["Details"] = "Application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(CreateApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(CreateApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Application status";
    ViewApplicationMenuHeadings["Location"] = "Location details";
    ViewApplicationMenuHeadings["Details"] = "Application details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let AStrategyService = class AStrategyService extends AflaModuleStrategyService {
    static { AStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    applicationCreateService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.Advertising;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiAdvertisingConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = AExpandListForApplicationSearch;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    previousApplication = null;
    savedApplication;
    postApplicationSubscription;
    getApplicationsSubscription;
    constructor(saShortDatePipe, applicationSearchService, applicationCreateService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.applicationCreateService = applicationCreateService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiAdvertisingConstants.URL}/${ApiAdvertisingConstants.FUNCTION_GET_MY_AFLA_ADVERTISING_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, AExpandListForApplicationSearch);
    }
    buildListFilter(list, column) {
        const params = AStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: AStrategyService_1.getRecipientName(AStrategyService_1.getFirstRecipient(application.applicant)),
            type: application.type,
            startDate: this.saShortDatePipe.transform(application.createdDate),
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.Details, ViewApplicationDetailsAComponent],
            [ViewApplicationMenuHeadings.Location, ViewApplicationLocationAComponent],
            [ViewApplicationMenuHeadings.Notes, ViewApplicationNotesComponent],
            [ViewApplicationMenuHeadings.Documentation, ViewApplicationDocumentationComponent]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationMenuHeadings.Details, CreateApplicationDetailsAComponent],
            [CreateApplicationMenuHeadings.Location, CreateApplicationLocationAComponent],
            [CreateApplicationMenuHeadings.Notes, CreateApplicationNotesComponent],
            [CreateApplicationMenuHeadings.Documentation, CreateApplicationDocumentationComponent]
        ]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiAdvertisingConstants.URL}/${ApiAdvertisingConstants.FUNCTION_GET_ALL_AFLA_PORTAL_ADVERTISING_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = AStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, AStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription = this.postApplicationService(application).subscribe({
            next: (savedApplication) => {
                this.appController.showMessage(AStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
                this.resetForm();
                this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]).then();
            }, error: (error) => {
                this.appController.handleServerErrorMessage("create advertising application", error, CRUDOperation.Add);
            }
        });
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        // @ts-ignore
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                application = this.setAdvertisementsGeometry(step.stepIndex, existingApplication, missingLookupsForZones);
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                aApplication: application, moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this because the saved application object does not return with the latest property owners
                    const params = {
                        $expand: "point,polygon,personResponsible,notes",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            const point = response.value[0]?.point;
                            const polygon = response.value[0]?.polygon;
                            savedApplication.point = point;
                            savedApplication.polygon = polygon;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        }, error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(AStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FEEL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.aApplication.eLodgementStep;
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(AStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                }, error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        return;
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiAdvertisingConstants.URL}/${applicationId}/${ApiAdvertisingConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        return this.http.post(`${ApiAdvertisingConstants.URL}/${applicationId}/${ApiAdvertisingConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    getCurrentFormName(step) {
        if (step == null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                formName = "advertisementsForm";
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetForm() {
        this.form.reset();
        this.form.get("advertisementsForm").get("advertisements").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiAdvertisingConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), lastEditedUser, notes";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_TP_APPLICATIONS_BY_USER;
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === CreateApplicationMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiAdvertisingConstants.URL}/${jobId}/${ApiAdvertisingConstants.FUNCTION_GET_APPLICATION_TYPE}`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("advertisementsForm") && this.form.get("advertisementsForm").get("advertisements")) {
            const advertisementsArray = this.form.get("advertisementsForm").get("advertisements");
            if (advertisementsArray.controls.length > 0) {
                return true;
            }
            else {
                this.appController.showMessage(CreateApplicationLocationAConstants.FEATURE_REQUIRED, AlertType.Warning);
                return false;
            }
        }
        else {
            this.appController.showMessage(CreateApplicationLocationAConstants.FEATURE_REQUIRED, AlertType.Warning);
            return false;
        }
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                this.form.get("detailsForm").get("description").reset();
                this.form.get("detailsForm").get("displayStartDate").reset();
                this.form.get("detailsForm").get("displayEndDate").reset();
                this.form.get("detailsForm").get("permanentApplicationDuration").reset();
                this.form.get("detailsForm").get("displayRemovalDate").reset();
                this.form.get("detailsForm").get("numberOfPosters").reset();
                this.form.get("detailsForm").get("nameOfBusiness").reset();
                this.form.get("detailsForm").get("notifySignageRemovalPeriod").reset();
                this.form.get("detailsForm").get("positionOfDisplay").reset();
                this.form.get("detailsForm").get("dimensionsH").reset();
                this.form.get("detailsForm").get("dimensionsW").reset();
                this.form.get("detailsForm").get("dimensionsD").reset();
                this.form.get("detailsForm").get("material").reset();
                this.form.get("detailsForm").get("colours").reset();
                this.form.get("detailsForm").get("frontalArea").reset();
                this.form.get("detailsForm").get("totalArea").reset();
                this.form.get("detailsForm").get("signType").reset();
                this.form.get("detailsForm").get("weight").reset();
                this.form.get("detailsForm").get("wattage").reset();
                this.form.get("detailsForm").get("contractorName").reset();
                this.form.get("detailsForm").get("contractorAddress").reset();
                this.form.get("detailsForm").get("contractorTelephone").reset();
                this.form.get("detailsForm").get("forSale").reset();
                this.form.get("detailsForm").get("onShow").reset();
                this.form.get("detailsForm").get("toLet").reset();
                this.form.get("detailsForm").get("sold").reset();
                this.form.get("detailsForm").get("constructionBoardSign").reset();
                this.form.get("detailsForm").get("otherOneYear").reset();
                this.form.get("detailsForm").get("groundSign").reset();
                this.form.get("detailsForm").get("flag").reset();
                this.form.get("detailsForm").get("sandwichBoard").reset();
                this.form.get("detailsForm").get("pylon").reset();
                this.form.get("detailsForm").get("wallSign").reset();
                this.form.get("detailsForm").get("billboard").reset();
                this.form.get("detailsForm").get("buildingAttachment").reset();
                this.form.get("detailsForm").get("projectingWallSign").reset();
                this.form.get("detailsForm").get("wallPainted").reset();
                this.form.get("detailsForm").get("roofSign").reset();
                this.form.get("detailsForm").get("skySign").reset();
                this.form.get("detailsForm").get("veranda").reset();
                this.form.get("detailsForm").get("aerialSign").reset();
                this.form.get("detailsForm").get("windowSign").reset();
                this.form.get("detailsForm").get("schoolSign").reset();
                this.form.get("detailsForm").get("combinationSign").reset();
                this.form.get("detailsForm").get("underAwningSign").reset();
                this.form.get("detailsForm").get("flagSign").reset();
                this.form.get("detailsForm").get("canopy").reset();
                this.form.get("detailsForm").get("balcony").reset();
                this.form.get("detailsForm").get("electronicSign").reset();
                this.form.get("detailsForm").get("developmentBoard").reset();
                this.form.get("detailsForm").get("otherFiveYear").reset();
                this.form.get("detailsForm").get("nonIlluminatedBillboard").reset();
                this.form.get("detailsForm").get("digitalBillboard").reset();
                this.form.get("detailsForm").get("nonIlluminatedGantry").reset();
                this.form.get("detailsForm").get("digitalGantry").reset();
                this.form.get("detailsForm").get("internallyIlluminatedBillboard").reset();
                this.form.get("detailsForm").get("internallyIlluminatedGantry").reset();
                this.form.get("detailsForm").get("municipalConsumerAccountNumber").reset();
                this.form.get("detailsForm").get("personResponsibleId").reset();
                this.form.get("detailsForm").get("referenceNumber").reset();
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("advertisementsForm").get("advertisements").clear();
                this.form.get("advertisementsForm").get("isAdvetisingPermanentOrTemporary").reset();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                this.form.get("notesForm").get("note").reset();
                break;
            default:
                break;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    setAdvertisementsGeometry(stepIndex, existingApplication, missingLookupsForZones) {
        let application;
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const applicationTypeValue = selectedPropertyFormGroup.get("type").value;
        const isAdvertisingPermanentOrTemporaryValue = this.form.get("advertisementsForm").get("isAdvetisingPermanentOrTemporary").value;
        const normalizedAdvertisementType = this.normalizeAdvertisementType(isAdvertisingPermanentOrTemporaryValue);
        if (existingApplication) {
            application = existingApplication;
            application.isAdvetisingPermanentOrTemporary = isAdvertisingPermanentOrTemporaryValue;
            application.type = applicationTypeValue;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appController.selectedModuleID),
                deleted: false,
                isAdvetisingPermanentOrTemporary: isAdvertisingPermanentOrTemporaryValue,
                type: applicationTypeValue,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                shape: "",
                wkid: 102100
            };
        if (normalizedAdvertisementType === CreateApplicationLocationAConstants.PERMANENT_ADVERTISEMENT_TYPE) {
            this.setApplicationPointData(application);
        }
        if (normalizedAdvertisementType === CreateApplicationLocationAConstants.TEMPORARY_ADVERTISEMENT_TYPE) {
            this.setApplicationPolygonData(application);
        }
        return application;
    }
    normalizeAdvertisementType(advertisementType) {
        if (!advertisementType) {
            return "";
        }
        return advertisementType.trim().toLowerCase();
    }
    setApplicationPointData(application) {
        const points = [];
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const centroid = selectedPropertyFormGroup.get("centroid").value;
        const geometry = selectedPropertyFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        points.push(`(${centroid.x} ${centroid.y})`);
        const pointShape = `POINT ${points.join(", ")}`;
        application.point = {
            id: 0,
            addressStreetInformation: selectedPropertyFormGroup.get("addressStreetInformation").value,
            shape: geometryJSON,
            wkid: 102100,
            deleted: false
        };
        application.shape = pointShape;
    }
    setApplicationPolygonData(application) {
        const points = [];
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        propertyArray.controls.forEach((selectedPropertyControl) => {
            const centroid = selectedPropertyControl.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
        });
        const polygonShape = `POINT ${points.join(", ")}`;
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const geometry = selectedPropertyFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        application.polygon = {
            id: 0,
            areaOfDisplay: selectedPropertyFormGroup.get("areaOfDisplay").value,
            streetNames: selectedPropertyFormGroup.get("streetNames").value,
            propertyDescription: selectedPropertyFormGroup.get("propertyDescription").value,
            shape: geometryJSON,
            wkid: 102100,
            deleted: false
        };
        application.shape = polygonShape;
    }
    buildDetailsStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.shape = existingApplication.shape;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                referenceNumber: "",
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: false,
            };
        application.description = this.form.get("detailsForm").get("description").value;
        application.displayStartDate = this.form.get("detailsForm").get("displayStartDate").value;
        application.displayEndDate = this.form.get("detailsForm").get("displayEndDate").value;
        application.permanentApplicationDuration = this.form.get("detailsForm").get("permanentApplicationDuration").value;
        application.displayRemovalDate = this.form.get("detailsForm").get("displayRemovalDate").value;
        application.numberOfPosters = this.form.get("detailsForm").get("numberOfPosters").value === null ? 0 : this.form.get("detailsForm").get("numberOfPosters").value;
        application.nameOfBusiness = this.form.get("detailsForm").get("nameOfBusiness").value;
        application.notifySignageRemovalPeriod = this.form.get("detailsForm").get("notifySignageRemovalPeriod").value;
        application.positionOfDisplay = this.form.get("detailsForm").get("positionOfDisplay").value;
        application.dimensionsH = this.form.get("detailsForm").get("dimensionsH").value === null ? 0.00 : this.form.get("detailsForm").get("dimensionsH").value;
        application.dimensionsW = this.form.get("detailsForm").get("dimensionsW").value === null ? 0.00 : this.form.get("detailsForm").get("dimensionsW").value;
        application.dimensionsD = this.form.get("detailsForm").get("dimensionsD").value === null ? 0.00 : this.form.get("detailsForm").get("dimensionsD").value;
        application.material = this.form.get("detailsForm").get("material").value;
        application.colours = this.form.get("detailsForm").get("colours").value;
        application.frontalArea = this.form.get("detailsForm").get("frontalArea").value === null ? 0.00 : this.form.get("detailsForm").get("frontalArea").value;
        application.totalArea = this.form.get("detailsForm").get("totalArea").value === null ? 0.00 : this.form.get("detailsForm").get("totalArea").value;
        application.signType = this.form.get("detailsForm").get("signType").value;
        application.weight = this.form.get("detailsForm").get("weight").value;
        application.wattage = this.form.get("detailsForm").get("wattage").value;
        application.contractorName = this.form.get("detailsForm").get("contractorName").value;
        application.contractorAddress = this.form.get("detailsForm").get("contractorAddress").value;
        application.contractorTelephone = this.form.get("detailsForm").get("contractorTelephone").value;
        application.forSale = this.form.get("detailsForm").get("forSale").value === null ? false : this.form.get("detailsForm").get("forSale").value;
        application.onShow = this.form.get("detailsForm").get("onShow").value === null ? false : this.form.get("detailsForm").get("onShow").value;
        application.toLet = this.form.get("detailsForm").get("toLet").value === null ? false : this.form.get("detailsForm").get("toLet").value;
        application.sold = this.form.get("detailsForm").get("sold").value === null ? false : this.form.get("detailsForm").get("sold").value;
        application.constructionBoardSign = this.form.get("detailsForm").get("constructionBoardSign").value === null ? false : this.form.get("detailsForm").get("constructionBoardSign").value;
        application.otherOneYear = this.form.get("detailsForm").get("otherOneYear").value;
        application.groundSign = this.form.get("detailsForm").get("groundSign").value === null ? false : this.form.get("detailsForm").get("groundSign").value;
        application.flag = this.form.get("detailsForm").get("flag").value === null ? false : this.form.get("detailsForm").get("flag").value;
        application.sandwichBoard = this.form.get("detailsForm").get("sandwichBoard").value === null ? false : this.form.get("detailsForm").get("sandwichBoard").value;
        application.pylon = this.form.get("detailsForm").get("pylon").value === null ? false : this.form.get("detailsForm").get("pylon").value;
        application.wallSign = this.form.get("detailsForm").get("wallSign").value === null ? false : this.form.get("detailsForm").get("wallSign").value;
        application.billboard = this.form.get("detailsForm").get("billboard").value === null ? false : this.form.get("detailsForm").get("billboard").value;
        application.buildingAttachment = this.form.get("detailsForm").get("buildingAttachment").value === null ? false : this.form.get("detailsForm").get("buildingAttachment").value;
        application.projectingWallSign = this.form.get("detailsForm").get("projectingWallSign").value === null ? false : this.form.get("detailsForm").get("projectingWallSign").value;
        application.wallPainted = this.form.get("detailsForm").get("wallPainted").value === null ? false : this.form.get("detailsForm").get("wallPainted").value;
        application.roofSign = this.form.get("detailsForm").get("roofSign").value === null ? false : this.form.get("detailsForm").get("roofSign").value;
        application.skySign = this.form.get("detailsForm").get("skySign").value === null ? false : this.form.get("detailsForm").get("skySign").value;
        application.veranda = this.form.get("detailsForm").get("veranda").value === null ? false : this.form.get("detailsForm").get("veranda").value;
        application.aerialSign = this.form.get("detailsForm").get("aerialSign").value === null ? false : this.form.get("detailsForm").get("aerialSign").value;
        application.windowSign = this.form.get("detailsForm").get("windowSign").value === null ? false : this.form.get("detailsForm").get("windowSign").value;
        application.schoolSign = this.form.get("detailsForm").get("schoolSign").value === null ? false : this.form.get("detailsForm").get("schoolSign").value;
        application.combinationSign = this.form.get("detailsForm").get("combinationSign").value === null ? false : this.form.get("detailsForm").get("combinationSign").value;
        application.underAwningSign = this.form.get("detailsForm").get("underAwningSign").value === null ? false : this.form.get("detailsForm").get("underAwningSign").value;
        application.flagSign = this.form.get("detailsForm").get("flagSign").value === null ? false : this.form.get("detailsForm").get("flagSign").value;
        application.canopy = this.form.get("detailsForm").get("canopy").value === null ? false : this.form.get("detailsForm").get("canopy").value;
        application.balcony = this.form.get("detailsForm").get("balcony").value === null ? false : this.form.get("detailsForm").get("balcony").value;
        application.electronicSign = this.form.get("detailsForm").get("electronicSign").value === null ? false : this.form.get("detailsForm").get("electronicSign").value;
        application.developmentBoard = this.form.get("detailsForm").get("developmentBoard").value === null ? false : this.form.get("detailsForm").get("developmentBoard").value;
        application.otherFiveYear = this.form.get("detailsForm").get("otherFiveYear").value;
        application.nonIlluminatedBillboard = this.form.get("detailsForm").get("nonIlluminatedBillboard").value;
        application.digitalBillboard = this.form.get("detailsForm").get("digitalBillboard").value;
        application.nonIlluminatedGantry = this.form.get("detailsForm").get("nonIlluminatedGantry").value;
        application.digitalGantry = this.form.get("detailsForm").get("digitalGantry").value;
        application.internallyIlluminatedBillboard = this.form.get("detailsForm").get("internallyIlluminatedBillboard").value;
        application.internallyIlluminatedGantry = this.form.get("detailsForm").get("internallyIlluminatedGantry").value;
        application.municipalConsumerAccountNumber = this.form.get("detailsForm").get("municipalConsumerAccountNumber").value;
        application.personResponsibleId = this.form.get("detailsForm").get("personResponsibleId").value;
        application.referenceNumber = this.form.get("detailsForm").get("referenceNumber").value;
        const personResponsibleValue = this.form.get("detailsForm").get("personResponsible").value;
        const personResponsible = RecipientUtils.removeInvalidRecipientProperties(personResponsibleValue);
        application.personResponsible = personResponsible ? [personResponsible] : [];
        return application;
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    buildApplication(existingApplication) {
        return {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: "",
            type: "",
            wkid: 102100,
            eLodgementStep: 0,
            eLodgementComplete: true,
        };
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicant = [applicant];
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(existingApplication);
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicant: [applicant],
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
            RecipientUtils.cleanPropertyOwners(existingApplication);
        }
        else {
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        }
        return application;
    }
    initForm() {
        this.form = new FormGroup({
            advertisementsForm: new FormGroup({
                advertisements: new FormArray([], [minLengthArray(1), Validators.required]),
                isAdvetisingPermanentOrTemporary: new FormControl(null, Validators.required),
                type: new FormControl(null, Validators.required)
            }), detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]), permanentApplicationDuration: new FormControl(null), // will the permanent advertising be there for 1 year or 5 years?
                displayStartDate: new FormControl(null), // temporary application types
                displayEndDate: new FormControl(null), // temporary application types
                displayRemovalDate: new FormControl(null), // temporary application types
                numberOfPosters: new FormControl(0), // temporary application types
                applicationDuration: new FormControl(null), // permanent application types
                nameOfBusiness: new FormControl(null), // permanent application types
                notifySignageRemovalPeriod: new FormControl(null), // permanent application types
                positionOfDisplay: new FormControl(null), // permanent application types
                dimensionsH: new FormControl(0.0), // permanent application types
                dimensionsW: new FormControl(0.0), // permanent application types
                dimensionsD: new FormControl(0.0), // permanent application types
                material: new FormControl(null), // permanent application types
                colours: new FormControl(null), // permanent application types
                frontalArea: new FormControl(0.0), // permanent application types
                totalArea: new FormControl(0.0), // permanent application types
                signType: new FormControl(null), // permanent application types
                weight: new FormControl(0.0), // permanent application types
                wattage: new FormControl(0.0), // permanent application types
                contractorName: new FormControl(null), // permanent application types
                contractorAddress: new FormControl(null), // permanent application types
                contractorTelephone: new FormControl(null, phoneNumberValidator), // permanent application types
                forSale: new FormControl(false), // permanent application types
                onShow: new FormControl(false), // permanent application types
                toLet: new FormControl(false), // permanent application types
                sold: new FormControl(false), // permanent application types
                constructionBoardSign: new FormControl(false), // permanent application types
                otherOneYear: new FormControl(null), // permanent application types
                groundSign: new FormControl(false), // permanent application types
                flag: new FormControl(false), // permanent application types
                sandwichBoard: new FormControl(false), // permanent application types
                pylon: new FormControl(false), // permanent application types
                wallSign: new FormControl(false), // permanent application types
                billboard: new FormControl(false), // permanent application types
                buildingAttachment: new FormControl(false), // permanent application types
                projectingWallSign: new FormControl(false), // permanent application types
                wallPainted: new FormControl(false), // permanent application types
                roofSign: new FormControl(false), // permanent application types
                skySign: new FormControl(false), // permanent application types
                veranda: new FormControl(false), // permanent application types
                aerialSign: new FormControl(false), // permanent application types
                windowSign: new FormControl(false), // permanent application types
                schoolSign: new FormControl(false), // permanent application types
                combinationSign: new FormControl(false), // permanent application types
                underAwningSign: new FormControl(false), // permanent application types
                flagSign: new FormControl(false), // permanent application types
                canopy: new FormControl(false), // permanent application types
                balcony: new FormControl(false), // permanent application types
                electronicSign: new FormControl(false), // permanent application types
                developmentBoard: new FormControl(false), // permanent application types
                otherFiveYear: new FormControl(null), // permanent application types
                nonIlluminatedBillboard: new FormControl(null), // permanent application types
                digitalBillboard: new FormControl(null), // permanent application types
                nonIlluminatedGantry: new FormControl(null), // permanent application types
                digitalGantry: new FormControl(null), // permanent application types
                internallyIlluminatedBillboard: new FormControl(null), // permanent application types
                internallyIlluminatedGantry: new FormControl(null), // permanent application types
                municipalConsumerAccountNumber: new FormControl(null), // permanent application types
                personResponsibleId: new FormControl(null), // permanent application types
                personResponsible: new FormControl([]), referenceNumber: new FormControl(null)
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            })
        });
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return;
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
AStrategyService = AStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsubPortal()
], AStrategyService);
export { AStrategyService };
